/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * If this is updated, DATA_TYPE_BYTES must also be updated.
 */
export var DataType;
(function (DataType) {
    DataType[DataType["UINT8"] = 0] = "UINT8";
    DataType[DataType["INT8"] = 1] = "INT8";
    DataType[DataType["UINT16"] = 2] = "UINT16";
    DataType[DataType["INT16"] = 3] = "INT16";
    DataType[DataType["UINT32"] = 4] = "UINT32";
    DataType[DataType["INT32"] = 5] = "INT32";
    DataType[DataType["UINT64"] = 6] = "UINT64";
    DataType[DataType["FLOAT32"] = 7] = "FLOAT32";
})(DataType || (DataType = {}));
export const DATA_TYPE_SIGNED = {
    [DataType.UINT8]: false,
    [DataType.INT8]: true,
    [DataType.UINT16]: false,
    [DataType.INT16]: true,
    [DataType.UINT32]: false,
    [DataType.INT32]: true,
    [DataType.UINT64]: false,
    [DataType.FLOAT32]: undefined
};
export const DATA_TYPE_BYTES = {
    [DataType.UINT8]: 1,
    [DataType.INT8]: 1,
    [DataType.UINT16]: 2,
    [DataType.INT16]: 2,
    [DataType.UINT32]: 4,
    [DataType.INT32]: 4,
    [DataType.UINT64]: 8,
    [DataType.FLOAT32]: 4
};
export const DATA_TYPE_ARRAY_CONSTRUCTOR = {
    [DataType.UINT8]: Uint8Array,
    [DataType.INT8]: Int8Array,
    [DataType.UINT16]: Uint16Array,
    [DataType.INT16]: Int16Array,
    [DataType.UINT32]: Uint32Array,
    [DataType.INT32]: Int32Array,
    [DataType.UINT64]: Uint32Array,
    [DataType.FLOAT32]: Float32Array
};
export const DATA_TYPE_JAVASCRIPT_ELEMENTS_PER_ARRAY_ELEMENT = {
    [DataType.UINT8]: 1,
    [DataType.INT8]: 1,
    [DataType.UINT16]: 1,
    [DataType.INT16]: 1,
    [DataType.UINT32]: 1,
    [DataType.INT32]: 1,
    [DataType.UINT64]: 2,
    [DataType.FLOAT32]: 1
};
export function makeDataTypeArrayView(dataType, buffer, byteOffset = 0, byteLength = buffer.byteLength) {
    const bytesPerElement = DATA_TYPE_BYTES[dataType];
    const javascriptElementsPerArrayElement = DATA_TYPE_JAVASCRIPT_ELEMENTS_PER_ARRAY_ELEMENT[dataType];
    return new DATA_TYPE_ARRAY_CONSTRUCTOR[dataType](buffer, byteOffset, byteLength / bytesPerElement * javascriptElementsPerArrayElement);
}
//# sourceMappingURL=data_type.js.map